/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdParagraphProps } from './type';
const props: TdParagraphProps = {
  /** 段落内容 */
  content: {
    type: String,
  },
  /** 是否省略展示，可通过配置参数自定义省略操作的具体功能和样式 */
  ellipsis: {
    type: null,
    value: false,
  },
};

export default props;
